import {t} from "i18next";

export const translateRecharge = str => {
  switch (str) {
    case "Alle 30 Tage":
      return t("subscription.delivery_30_day");
    case "Alle 60 Tage":
        return t("subscription.delivery_60_day");
    case "Alle 90 Tage":
      return t("subscription.delivery_90_day");
    case "Alle 120 Tage":
      return t("subscription.delivery_120_day");
    // Stay.ai's raw "Deliver every" option value ("60 days") — what the sticky bar prints after
    // the price. Without a mapping it leaked through in English on the German storefront.
    case "30-day":
    case "30 days":
      return t("subscription.add_to_cart.30_day");
    case "60-day":
    case "60 days":
      return t("subscription.add_to_cart.60_day");
    case "90-day":
    case "90 days":
      return t("subscription.add_to_cart.90_day");
    case "120-day":
    case "120 days":
      return t("subscription.add_to_cart.120_day");
    default:
      return str;
  }
};
